import { useState, useEffect } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "./ui/button";
import { X } from "lucide-react";

const CookieBanner = () => {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      // Delay showing cookie banner to prevent it from being the LCP element
      // This ensures hero content renders first and becomes the LCP
      const timer = setTimeout(() => setIsVisible(true), 2500);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setIsVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem("cookieConsent", "declined");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border shadow-lg"
      role="region"
      aria-labelledby="cookie-banner-title"
      aria-describedby="cookie-banner-description"
      aria-live="polite"
    >
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1">
            <h2 id="cookie-banner-title" className="text-lg font-semibold text-foreground mb-2">
              {t('cookies.title')}
            </h2>
            <p id="cookie-banner-description" className="text-sm text-muted-foreground">
              {t('cookies.description')}
            </p>
          </div>
          <div className="flex gap-3 w-full md:w-auto">
            <Button
              onClick={declineCookies}
              variant="outline"
              className="flex-1 md:flex-none min-h-[44px]"
              aria-label={t('cookies.decline')}
            >
              {t('cookies.decline')}
            </Button>
            <Button
              onClick={acceptCookies}
              className="flex-1 md:flex-none bg-accent hover:bg-accent/90 text-accent-foreground min-h-[44px]"
              aria-label={t('cookies.accept')}
            >
              {t('cookies.accept')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;